import React from 'react';
import { DeploymentNotifier } from '@marageti/z4-lib';
import { usePusherStore } from '../../store';
import config from '../../config';

const PartnerDeploymentNotifier = () => {
  const { pusherClient } = usePusherStore();

  return (
    <DeploymentNotifier
      appName="partner"
      pusherClient={pusherClient}
      channel={config.DEPLOYMENT_CHANNEL}
    />
  );
};

export default PartnerDeploymentNotifier;
